import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Section from 'components/common/Section';
import Logo from 'components/common/Logo';

const WizardAuth = ({ Component }) => {
  return (
    <Section className="py-0">
      <Row className="justify-content-center pt-6">
        <Col sm={10} lg={12} className="col-xxl-7">
          <Logo width={45} textClass="fs-4" />
          <Component validation={true} />
        </Col>
      </Row>
    </Section>
  );
};
WizardAuth.propTypes = {
  Component: PropTypes.element
}

export default WizardAuth;
